import React from "react";
import { business } from "../../mock/mock";
import CircleArrowLink from "../common/CircleArrowLink";
import Reveal from "../common/Reveal";
import { MapPin } from "lucide-react";

const LocationCTA = () => {
  return (
    <section className="py-20 lg:py-28">
      <div className="tnf-container">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 items-stretch">
          <Reveal className="flex flex-col justify-center order-2 lg:order-1">
            <span className="tnf-eyebrow inline-flex items-center gap-2">
              <MapPin size={15} /> Find Us
            </span>
            <h2 className="font-display text-[30px] sm:text-[40px] font-extrabold text-[#0e0e10] mt-3 leading-[1.1]">
              Visit Us Inside the Freehold Raceway Mall Today!
            </h2>
            <p className="text-[#3b3b3b]/80 text-[16px] mt-4 max-w-lg leading-relaxed">
              You'll find us on the <strong className="text-[#0e0e10] font-semibold">2nd level, right by the food court</strong> inside
              the Freehold Raceway Mall. Drop off your device while you shop or
              grab a coffee, and get turn-by-turn directions instantly.
            </p>
            <div className="mt-6 flex flex-wrap items-center gap-4">
              <CircleArrowLink href={business.directionsUrl} variant="orange">
                Take me there
              </CircleArrowLink>
              <div className="text-[14px] text-[#3b3b3b]/80">
                <div className="font-semibold text-[#0e0e10]">
                  {business.addressLine1}
                </div>
                {business.addressLine2}
                <div className="text-[var(--tnf-blue)] font-medium mt-0.5">
                  {business.floor}
                </div>
              </div>
            </div>
          </Reveal>

          <Reveal
            delay={120}
            className="order-1 lg:order-2 rounded-[24px] overflow-hidden border border-black/5 shadow-[0_18px_50px_rgba(0,0,0,0.08)] min-h-[340px]"
          >
            <iframe
              title="Talk N' Fix location"
              src={business.mapEmbed}
              className="w-full h-full min-h-[340px]"
              style={{ border: 0 }}
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
            />
          </Reveal>
        </div>
      </div>
    </section>
  );
};

export default LocationCTA;
